import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  created: null,
  updated: null,
  disabledRestored: null,
};

const warehouseSlice = createSlice({
  name: 'warehouse',
  initialState,
  reducers: {
    setCreatedWarehouse: (state, action) => {
      state.created = action.payload;
    },
    setUpdatedWarehouse: (state, action) => {
      state.updated = action.payload;
    },
    setDisabledRestoredWarehouse: (state, action) => {
      state.disabledRestored = action.payload;
    },
  },
});

export const { setCreatedWarehouse, setUpdatedWarehouse, setDisabledRestoredWarehouse } = warehouseSlice.actions;
export default warehouseSlice.reducer;
